<template>
     <div class="container-fluid">
        <div class="w-100 px-5 py-4">
            <!-- TITULO Y ENCABEZADOS -->
            <div>
                <h1>EDICIÓN DE CONTENIDO</h1>
                <h4>Busque el contenido de la página web y realice los cambios necesarios</h4>
            </div>
            <!-- Componentes de Paso 1 y 2 -->
            <div class="paso-dos-tres row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
               <CEdicionDeContenido  v-on:BusquedaContenidos="evtBusquedaContenidos"></CEdicionDeContenido>
              </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 padding-bottom" >
                  <div id="titulo-resultados">
                    <div class="form-inline justify-content-between">
                        <h4>Listado de contenidos {{obtenerTituloDeSeccion}}</h4>
                       <button v-if="mostrarBotonOrden"  type="button" class="btn btn-sm btn btn-light" v-on:click="mostrarOrdenamiento"><i class="fas fa-sort-numeric-up"></i>&nbsp;Ordena Contenido</button>
                    </div>
                    </div>
                  <!-- <ul class="nav nav-tabs" id="nav-tab-formulario-paso-dos" role="tablist">
                    <li class="nav-item" v-if="mostrarFormularioDeEdicion">
                      <a class="nav-link active" id="agregar-tab" data-toggle="tab" href="#modificar-contenido" role="tab" aria-controls="agregar-contenido" aria-selected="true">Modificar Contenido</a>
                    </li>
                    <li class="nav-item" v-if="mostrarFormularioDeEdicion">
                      <a class="nav-link" id="ordenar-tab" data-placement="top" v-tooltip:top="tituloToggleOrdenContenido" data-toggle="tab" href="#ordenar-contenido" role="tab" data-original-title="Ordena los de contenidos de una página" aria-controls="ordenar-contenido" aria-selected="true">Modificar Orden de Contenidos</a>
                    </li>
                  </ul> -->
                  <div class="nav_tab_formularios" >
                    <div id="contenidos_seccion">
                          <table
                            class="table table-striped table-light table-hover"
                            id="tabla-contenidos"              
                            data-toggle="table"
                            data-pagination="true"
                            data-undefined-text="Sin información"  
                            data-page-size = "5"
                            data-page-list="[5,10,20]"
                            data-click-to-select="false"
                            data-search="true"
                            >
                            
                            <thead class="thead-green">
                                <tr>
                                   
                                    <th data-halign="center" data-width="10" data-align="center" data-field="ContenidoDeMicrositioId" data-sortable="true">
                                        Folio
                                    </th>
                                     <th data-halign="center" data-width="20" data-align="center" data-field="RutaImagen"  data-sortable="true">
                                        Imagen
                                    </th>
                                     <th data-halign="center" data-width="20" data-align="center" data-field="RutaArchivo"  data-sortable="true">
                                        Archivo
                                    </th>
                                    <th data-halign="center" data-width="20" data-align="center" data-field="TextoDelContenidoPresentacion"  data-sortable="true">
                                        Texto Del Contenido
                                    </th>
                                     <th data-halign="center" data-width="20" data-align="center" data-field="TextoDelVinculo"  data-sortable="true">
                                        Texto Del Vinculo
                                    </th>
                                    <th data-halign="center" data-width="20" data-align="center" data-field="FechaDePublicacion" data-sortable="true">
                                        Fecha de Publicacion
                                    </th>
                                    <th data-halign="center" data-width="20" data-align="center" data-field="FechaDeModificacion" data-sortable="true">
                                        Fecha de Modificacion
                                    </th>
                                    <th data-events="operateEvents" data-halign="center" data-width="20" data-align="center" data-field="EstaActivo.html" data-sortable="true">
                                        Estado
                                    </th>
                                    <!-- <th data-events="operateEvents" data-width="40"  data-halign="center" data-align="center" :data-formatter="this.agregarAccionCancelar()">
                                        Cancelar
                                    </th>  -->
                                    <th data-events="operateEvents" data-width="40"  data-halign="center" data-align="center" :data-formatter="this.agregarAccionEditar()">
                                        Editar
                                    </th>
                                      <th data-field="copiar" data-events="operateEvents" data-width="40"  data-halign="center" data-align="center" :data-formatter="this.agregarAccionCopiarVinculo()">
                                        Copiar
                                    </th>
                                   
                                    
                                </tr> 
                            </thead>
                        </table>
                    </div>


<!--  TABLA DE CONTENIDOS DE CARRUSEL -->
<div id="contenido-carrusel"> 
                        <table
                            class="table table-striped table-light table-hover"
                            id="tabla-contenidos-carrusel"              
                            data-toggle="table"
                            data-pagination="true"
                            data-undefined-text="Sin información"  
                            data-page-size = "5"
                            data-page-list="[5,10,20]"
                            data-click-to-select="false"
                            data-search="true">
                            <thead class="thead-dark">
                                <tr>
                                    
                                    <th data-halign="center" data-width="10" data-align="center" data-field="ArchivoDeContenidoMicrositioId" data-sortable="true">
                                        Folio
                                    </th>
                                    <th data-halign="center" data-width="20" data-align="center" data-field="Titulo"  data-sortable="true">
                                        Titulo
                                    </th>
                                     <th data-halign="center" data-width="20" data-align="center" data-field="TextoDescripcion"  data-sortable="true">
                                        Texto Del Contenido
                                    </th>
                                     <th data-halign="center" data-width="20" data-align="center" data-field="RutaImagen"  data-sortable="true">
                                        Imagen
                                    </th>
                                    <th data-halign="center" data-width="20" data-align="center" data-field="FechaDeRegistro" data-sortable="true">
                                        Fecha de Registro
                                    </th>
                                    <th data-events="operateEvents" data-halign="center" data-width="20" data-align="center" data-field="EstaActivo.html" data-sortable="true">
                                        Estado
                                    </th>
                                    <th data-events="operateEvents" data-width="40"  data-halign="center" data-align="center" :data-formatter="this.agregarAccionEditar()">
                                        Editar
                                    </th>
                                    <!-- <th data-events="operateEvents" data-width="40"  data-halign="center" data-align="center" :data-formatter="this.agregarAccionDesactivar()">
                                        Cancelar
                                    </th> -->
                                    
                                </tr> 
                            </thead>
                        </table>
          </div>
<!-- FIN  TABLA DE CONTENIDOS DE CARRUSEL -->    
 <div class="tab-content" id="myTabContent" v-if="mostrarFormulariosDeEdicion">           
                    <div class="tab-pane fade show active" id="modificar-contenido" role="tabpanel" aria-labelledby="agregar-tab">
                      <CFormularioEdicionMicrositio v-if="mostrarFormularioDeEdicion" :contenido="contenido"  v-on:OcultarFormulario="evtOcultarFormulario" :key="ContenidoMicrositioId"></CFormularioEdicionMicrositio>
                    </div>
                     
                       <CFormularioPasoTres v-if="mostrarTablasYOrdenamiento.mostrarOrden"></CFormularioPasoTres>
                       
      </div>           
                 
                  </div>
                </div>
            </div>
            
        </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import api from '@/../static/js/api'
  import comun from "@/../static/js/comun"
  import moment from 'moment';
  import CEdicionDeContenido from '@/components/SICPO/Micrositios/Comun/CEdicionMicrositio.vue'
  import CFormularioEdicionMicrositio from '@/components/SICPO/Micrositios/Comun/CFormularioEdicionMicrositio.vue'
  import CFormularioPasoTres from '@/components/SICPO/Micrositios/Comun/CFormularioPasoTresMicrositio.vue'
    import ListaOrdenableDeContenido from '@/components/SICPO/Micrositios/ListaOrdenableDeContenidoMicrositio.vue'
  import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

  export default {
      components: {
          CEdicionDeContenido,
          CFormularioEdicionMicrositio,
          CFormularioPasoTres,
          ListaOrdenableDeContenido,
          
      },
      directives: {
          tooltipF,
          
      },
      data() {
          return {
            enumeraciones_sicpo,
            
  contenidos: {
                listaDeContenidosBD: [],
                listaDeContenidos: [],
                fechas: {
                    FORMATO: 'YYYY-MM-DD'
                },
                textoRecortado: {
                  INICIO:0,
                  FIN:100,
                  },
                filtrosBusqueda: null,
                contenidoSeleccionado: null,
                contenidosSeleccionados: []
            },

   archivosDeContenidos: {
                listaDeArchivosBD: [],
                listaDeArchivos: [],
                fechas: {
                    FORMATO: 'YYYY-MM-DD'
                },
                textoRecortado: {
                  INICIO:0,
                  FIN:100,
                  },
                filtrosBusqueda: null,
                archivosSeleccionado: null,
                archivosSeleccionados: []
            },


            parametrosFiltro:null,
            mostrarTablaContenidoCarrusel:false,
            mostrarSubidorDeArchivos: false,
            mostrarRealizarLaSubida: false,
            tituloToggleOrdenContenido: '',
            opcion1: '',
            opcion2: '',
            
            ContenidoMicrositioId:0,
            mostrarFormularioDeEdicion:false,
            mostrarTablasYOrdenamiento:{
              mostrarOrden:false,
              mostrarTablaContenido:false,
              mostrarTablaCarrusel:false
            },
            mostrarBotonOrden:false,
            SERVIDOR_LOCAL:'\\\\themisfs',
            mostrarColumnaCopiar:false,
            RUTA_VISOR: '/Ver/url?file=',
            TIPO_ARCHIVO:".pdf"
          }
      },
      methods: {
        mostrarOrdenamiento:function(){   
          this.mostrarTablasYOrdenamiento.mostrarOrden = !this.mostrarTablasYOrdenamiento.mostrarOrden;
          if( !this.mostrarTablasYOrdenamiento.mostrarOrden){
            if( !this.mostrarTablasYOrdenamiento.mostrarTablaContenido) $("#contenidos_seccion").show();
            if(!this.mostrarTablasYOrdenamiento.mostrarTablaCarrusel) $("#contenido-carrusel").show();
          }else{
              this.mostrarTablasYOrdenamiento.mostrarTablaContenido = $("#contenidos_seccion").is(":hidden");
          this.mostrarTablasYOrdenamiento.mostrarTablaCarrusel =   $("#contenido-carrusel").is(":hidden");
          $("#contenidos_seccion").hide(); 
          $("#contenido-carrusel").hide();
          }

          
          
        },
evtOcultarFormulario(ocultarFormulario){
   $("#contenidos_seccion").hide(); 
    $("#contenido-carrusel").hide();
   this.mostrarFormularioDeEdicion=ocultarFormulario.ocultaFormulario;
   if(ocultarFormulario.tipoTablaCarrusel) {
      $("#contenido-carrusel").show();
         this.obtenerListadoDeContenidos(this.parametrosFiltro);
    
     }
      else {
         $("#contenidos_seccion").show();
     this.obtenerListadoDeContenidos(this.parametrosFiltro);
      //  $("#contenido-carrusel").show();
       //  this.obtenerListadoDeContenidos(this.parametrosFiltro);
      }
         //   this.obtenerListadoDeContenidos(parametrosBusqueda);


},
        confirmarCanceladoDeContenido: function (contenido,index) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Esta a punto de cancelar el contenido<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.cancelarContenido(contenido,index)
                        
                    }
                }
            });
        },

       cancelarContenido:function(contenido,index){
           const SERVIDOR = api.conexion;         
           const METODO_API_AGREGAR = api.SICPO.sistema.micrositioweb.edicioncontenidomicrositio.EdicionDeContenidoMicrositio;
           let urlApi = SERVIDOR + METODO_API_AGREGAR;
           let peticionAPI = this.crearPeticionDeCancelado(contenido)
           let peticionArchivos = false;
           let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
            comun.SeEstaCargandoInformacion(true);
          axios.post(urlApi, peticionAPI, headerPeticion).then(respuesta=>{
           if(respuesta.data.SiHayError){
             let mensajeError = respuesta.data.Error.Mensaje;
             console.log(respuesta.data.Error.Mensaje)
             comun.informarError(mensajeError);
           }else{
             if(peticionAPI.SoloContenido){
               contenido.EstaActivo.activo = !contenido.EstaActivo.activo;    
               this.contenidos.listaDeContenidos[index] = contenido; 
             }
            if(peticionAPI.SoloArchivo){      
             contenido.EstaActivo.activo = !contenido.EstaActivo.activo; 
             this.archivosDeContenidos.listaDeArchivos[index] = contenido
            
             }
           comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
           }
           comun.SeEstaCargandoInformacion(false);
   
          }
           
           ).catch(error => {
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(error, null, null);
             console.error("ERROR::"+error)
           })

       },

       crearPeticionDeCancelado(contenido){
         var IdEdicionContenido= 0;
         var IdArchivoContenido=0;
         var SoloContenido=false;
         var SoloArchivo=false;
         var NuevoEstado = 0;
         if(contenido.EsArchivoDeContenido){
           IdArchivoContenido = contenido.ArchivoDeContenidoMicrositioId
           SoloArchivo = true;
           SoloContenido = false; 
         }
         else if(contenido.EsContenido){
           IdEdicionContenido= contenido.ContenidoDeMicrositioId;
           SoloContenido = true;
           SoloArchivo = false;
           NuevoEstado = (contenido.EstaActivo.activo ==true)? 4 : 2 
         }
         let peticionApi ={
            EsPrueba:false,
            idTipoEstatusDelContenidoId:NuevoEstado,
            archivoActivo: !contenido.EstaActivo.activo,
            idEdicionContenido:IdEdicionContenido,
            idArchivoContenido:IdArchivoContenido,
            ConContenidoYArchivo:false,
            SoloContenido:SoloContenido,
            SoloArchivo:SoloArchivo
         }
         return peticionApi;
       },


agregarContenidoAFormulario:function(row){
  console.log("row::",row)
  this.contenido=row;
  this.contenido.TipoTablaCarrusel=this.mostrarTablaContenidoCarrusel;
  this.ContenidoMicrositioId=(this.mostrarTablaContenidoCarrusel)?row.ArchivoDeContenidoMicrositioId:row.ContenidoDeMicrositioId;
  this.mostrarFormularioDeEdicion=true;
  this.mostrarBotonOrden=false;
},

        agregarAccionEditar:() => {
         return '<button id="btnEditar" class="btn btn-sm btn-xs btn btn-info align-middle align-center"><i class="fas fa-edit"></i>&nbsp;Editar</button>';
        
        },
         agregarAccionCancelar:() => {
         return '<button id="btnCancelar" class="btn btn-danger"><i class="far fa-window-close"></i></button>';

        
        
        },
        agregarAccionDesactivar:() =>{
          return '<button id="btnDesactivar" class="btn btn-danger"><i class="far fa-window-close"></i></button>';
        },
         agregarAccionCopiarVinculo:() =>{
          
           return  '<button id="btnCopiar" class="btn btn-info"><i class="far fa-copy"></i></button>';
         
        },

      

         evtBusquedaContenidos: function(parametrosBusqueda) {
           console.log("Parametros Busqueda::::",parametrosBusqueda)
            this.parametrosFiltro = parametrosBusqueda;
             this.$store.dispatch("A_SICPO_Micrositio_Edicion_mostrarTablaDeContenidos",false);
             this.mostrarFormularioDeEdicion = false;
             this.mostrarTablasYOrdenamiento.mostrarOrden=false;
            this.obtenerListadoDeContenidos(parametrosBusqueda);
        },

        obtenerListadoDeContenidos: function(parametros) {
            let formatoId = this.$store.getters.Get_SICPO_Catalogo_TipoDeFormulario.numeroFormato;
            const SERVIDOR = api.conexion;         
            const METODO_API_AGREGAR = api.SICPO.sistema.micrositioweb.altadecontenidomicrositio.ContenidosDeMicrositios;;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionAPI = {
               // PaginaWebId: paginaId,
              SeccionMicrositioId: parametros.seccionId,
              EsPrueba:false,
              SoloContenidoActivo:false
               // EsComunicado: esComunicado
            }
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
            .then(respuesta => {            
              if (respuesta.data.SiHayError) {
                console.log(respuesta); 
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              } 
              else { 
                
                    if(formatoId==32 || formatoId==15 || formatoId==26){
                       var archivosMicrositios = respuesta.data.ContenidosDeMicrositio.filter(filtra => filtra.ContenidoDeMicrositioId==parametros.carruselId)[0]                     
                       this.listaDeAcrhivosDeContenido = archivosMicrositios.ArchivosDeContenidoMicrositios;  
                      
                        this.$nextTick(async () => {
                          await Promise.resolve( this.llenarTablaDeContenidosDeCarrusel(archivosMicrositios.ArchivosDeContenidoMicrositios));
                       await Promise.resolve(this.persistirSwitchArchivosActivos())
                       });
                  }
                  else {
                      this.$nextTick(async () => {
                   await Promise.resolve(this.llenarTablaDeContenidos(respuesta.data.ContenidosDeMicrositio));
                                    await Promise.resolve(this.persistirSwitchAContenidosActivos());
                                });
                  //  this.llenarTablaDeContenidos(respuesta.data.ContenidosDeMicrositio); 
                  }
                   
                   let listaDeCotenidosOriginal = [];  
                   this.listaDeContenidos = respuesta.data.ContenidosDeMicrositio;
                   this.ordenarDesc(this.listaDeContenidos,'contenido.OrdenDelContenido');
                   listaDeCotenidosOriginal =  this.listaDeContenidos;        
                   this.mapearInformacionParaListado(listaDeCotenidosOriginal);
                   this.$store.dispatch("A_SICPO_Micrositio_Edicion_mostrarTablaDeContenidos",true);
                 
              
              }
               comun.SeEstaCargandoInformacion(false);
            })
            .catch(excepcion => {
              console.log(excepcion);
               comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(excepcion, null, null)
            }) // axios.post

        },

              ordenarAsc:function(p_array_json, p_key) {
                
                p_array_json.sort(function (a, b) {
                    return a[p_key] > b[p_key];
             });
                },
             ordenarDesc:function(p_array_json, p_key) {
                this.ordenarAsc(p_array_json, p_key); p_array_json.reverse(); 
                },

         mapearInformacionParaListado: function(listado) {
            let listaContenidosOriginal = [];
            var urgenteVisibleId = -1;
            let hoy = new Date();
            var j =0;
            for(var i=listado.length;i>0;i--){
            
                let elementoContenido = {
                     id: i, 
                     mostrarDescripcion:false, 
                     hover:false,
                     conIconoUrgenteVisible: false,
                     conIconoMostrarEnInicio: true,
                     contenido: listado[j]
                     
                 }
                 listaContenidosOriginal.push(elementoContenido);
                 j++;
             }
           
            this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal",listaContenidosOriginal);
         
        },

 persistirSwitchAContenidosActivos: async function() {
            if(this.contenidos.listaDeContenidos.length > 0) {
                this.contenidos.listaDeContenidos.forEach(cObj => {
                    const ID_SWITCH_ACTIVO_CONTENIDO = `check-contenido-activo-MIC-${ cObj.ContenidoDeMicrositioId }`;
                    $("#" + ID_SWITCH_ACTIVO_CONTENIDO).prop('checked',  cObj.EstaActivo.activo);
                });
            }
        },

 persistirSwitchArchivosActivos: async function() {
            if(this.archivosDeContenidos.listaDeArchivos.length > 0) {
                this.archivosDeContenidos.listaDeArchivos.forEach(cObj => {
                    const ID_SWITCH_ACTIVO_CONTENIDO = `check-contenido-activo-MIC-${ cObj.ArchivoDeContenidoMicrositioId }`;
                    $("#" + ID_SWITCH_ACTIVO_CONTENIDO).prop('checked',  cObj.EstaActivo.activo);
                });
            }
        },

 darFormatoObjetosDeContenido: async function(contenidos) {
            const ESTATUS_ACTIVO_ID = 2;
            this.contenidos.listaDeContenidos = contenidos.map(c => {
                let { FechaDeRegistro, FechaDePublicacion,FechaDeModificacion } = c;
                let contenidoConFormato = c;
                contenidoConFormato.FechaDeRegistro = moment(FechaDeRegistro).format(this.contenidos.fechas.FORMATO);
                contenidoConFormato.FechaDePublicacion = moment(FechaDePublicacion).format(this.contenidos.fechas.FORMATO);
                contenidoConFormato.FechaDeModificacion =(contenidoConFormato.FechaDeModificacion!=null)?moment(FechaDeModificacion).format(this.contenidos.fechas.FORMATO):"Sin Modificacion";
                contenidoConFormato.TextoDelContenidoPresentacion =( c.TextoDelContenido != "" &&  c.TextoDelContenido != null) ?c.TextoDelContenido.substring(this.contenidos.textoRecortado.INICIO,this.contenidos.textoRecortado.FIN):"";
                contenidoConFormato.RutaImagen =( c.RutaDeImagen != "" &&  c.RutaDeImagen != null) ?c.RutaDeImagen.split('\\')[c.RutaDeImagen.split('\\').length-1]:"";
                contenidoConFormato.RutaArchivo = ( c.RutaDeArchivo != "" &&  c.RutaDeArchivo != null) ?c.RutaDeArchivo.split('\\')[c.RutaDeArchivo.split('\\').length-1]:"";
                contenidoConFormato.TextoDelVinculo = (c.TextoDelVinculo == null && c.ArchivosDeContenidoMicrositios.length!= 0)?c.ArchivosDeContenidoMicrositios[0].TextoDescripcion:c.TextoDelVinculo;
                contenidoConFormato.EsArchivoDeContenido=false;
                contenidoConFormato.EsContenido=true;
              // contenidoConFormato.EsComunicado = (this.paginaRequiereComunicado(this.contenidos.filtrosBusqueda.paginaWebId)) ? 'Si' : 'No';
               // contenidoConFormato.EsDisposicionEspecial = (EsDisposicionEspecial) ? 'Si' : 'No';
                contenidoConFormato.EstaActivo = {
                    activo: (c.TipoEstatusDelContenido.TipoEstatusDelContenidoId == ESTATUS_ACTIVO_ID),
                    html: `<label id="switch-activo-inactivo-MIC-${ c.ContenidoDeMicrositioId }" class="switch-contenido-activo-MIC">
                            <input id="check-contenido-activo-MIC-${ c.ContenidoDeMicrositioId }" type="checkbox">
                            <div id="slider-activo-inactivo-MIC-${ c.ContenidoDeMicrositioId }" class="slider-contenido-activo-MIC"></div>
                           </label>`
                };
                return contenidoConFormato;
            });
        },




        llenarTablaDeContenidos: async function(elementos) {
          this.mostrarBotonOrden =true;
          this.mostrarColumnaCopiar=true;
          let formatoId =this.$store.getters.Get_SICPO_Catalogo_TipoDeFormulario.numeroFormato;
          await Promise.resolve(this.darFormatoObjetosDeContenido(elementos));
          this.mostrarTablaContenidoCarrusel=false;
          $("#contenidos_seccion").show();
          $("#contenido-carrusel").hide();

           $("#tabla-contenidos").bootstrapTable('showColumn',"RutaImagen");
           $("#tabla-contenidos").bootstrapTable('showColumn',"RutaArchivo");
          $("#tabla-contenidos").bootstrapTable('showColumn',"TextoDelContenidoPresentacion");    
          $("#tabla-contenidos").bootstrapTable('showColumn',"TextoDelVinculo");
          $("#tabla-contenidos").bootstrapTable('showColumn',"copiar");
          
            if (formatoId == 8 || formatoId ==18 || formatoId == 19 || formatoId == 24 || formatoId == 25 || formatoId == 28 ||  formatoId == 30 || formatoId == 27|| formatoId == 17 || formatoId == 47)
              $("#tabla-contenidos").bootstrapTable('hideColumn',"RutaImagen"); 
              if(formatoId == 18 || formatoId == 24 || formatoId == 25 ||  formatoId == 30 || formatoId == 27 || formatoId == 47){
              $("#tabla-contenidos").bootstrapTable('hideColumn',"RutaArchivo");
              }  
               if(formatoId ==8 || formatoId==16 ||formatoId == 19 ||formatoId == 20 || formatoId == 28 )  {
              $("#tabla-contenidos").bootstrapTable('hideColumn',"TextoDelContenidoPresentacion");
               }
             if(formatoId == 16 || formatoId == 24 || formatoId == 25 ||  formatoId == 30 || formatoId == 27){
              $("#tabla-contenidos").bootstrapTable('hideColumn',"TextoDelVinculo");
             }
              if(formatoId == 18 || formatoId == 24 ||  formatoId == 30){
              $("#tabla-contenidos").bootstrapTable('hideColumn',"copiar");
              }
       

          if( formatoId !=8 && formatoId != 16 && formatoId != 19 && formatoId != 20 && formatoId != 21 && formatoId != 22 && formatoId != 28 && formatoId != 29){
           $("#tabla-contenidos").bootstrapTable('hideColumn',"copiar");  
          }else{
             $("#tabla-contenidos").bootstrapTable('showColumn',"copiar");  
          }
          
          $("#tabla-contenidos").bootstrapTable({  data: this.contenidos.listaDeContenidos });
          $("#tabla-contenidos").bootstrapTable('load',  this.contenidos.listaDeContenidos); 
            
           
          

$('#tabla-contenidos').on('check.bs.table',(e, row) => {
                this.evtSeleccionoContenido(e, row);
            });
            $('#tabla-contenidos').on('uncheck.bs.table',(e, row) => {
                const TIPO_CHECK = 'UNO';
                this.evtRemoverContenidosEnListaSeleccionados(e, row,TIPO_CHECK);
            });
            $('#tabla-contenidos').on('check-all.bs.table',(e, rows) => {
                this.evtSeleccionoTodos(e, rows);
            });
            $('#tabla-contenidos').on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                const TIPO_CHECK = 'MUCHOS';
                this.evtRemoverContenidosEnListaSeleccionados(e, rowsBefore,TIPO_CHECK);
            });
            $('#tabla-contenidos').on('page-change.bs.table', (size, number) => {
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchAContenidosActivos());
                });
            });
          $("td[id^=switch-activo-inactivo-MIC]").addClass('switch-contenido-activo-MIC');
          $("td[id^=slider-activo-inactivo-MIC]").addClass('slider-contenido-activo-MIC');
        },


        darFormatoObjetosDeArchivosDeContenido: async function(archivos) {
            const ESTATUS_ACTIVO_ID = 2;
            this.archivosDeContenidos.listaDeArchivos = archivos.map(a => {
                let { FechaDeRegistro } = a;
                let archivoConFormato = a;
                archivoConFormato.FechaDeRegistro = moment(FechaDeRegistro).format(this.archivosDeContenidos.fechas.FORMATO);
              archivoConFormato.EsArchivoDeContenido=true;
              archivoConFormato.EsContenido=false;
              //  archivoConFormato.FechaDePublicacion = moment(FechaDePublicacion).format(this.contenidos.fechas.FORMATO);
              //  archivoConFormato.FechaDeModificacion =moment(FechaDeModificacion).format(this.contenidos.fechas.FORMATO);
              //  archivoConFormato.TextoDelContenidoPresentacion =( c.TextoDelContenido != "" &&  c.TextoDelContenido != null) ?c.TextoDelContenido.substring(this.contenidos.textoRecortado.INICIO,this.contenidos.textoRecortado.FIN):"";
                archivoConFormato.RutaImagen =( a.RutaDelArchivo != "" &&  a.RutaDelArchivo != null ) ?a.RutaDelArchivo.split('\\')[a.RutaDelArchivo.split('\\').length-1]:"Sin Imagen";
               // archivoConFormato.RutaArchivo = ( c.RutaDeArchivo != "" &&  c.RutaDeArchivo != null) ?c.RutaDeArchivo.split('\\')[c.RutaDeArchivo.split('\\').length-1]:"";
              // contenidoConFormato.EsComunicado = (this.paginaRequiereComunicado(this.contenidos.filtrosBusqueda.paginaWebId)) ? 'Si' : 'No';
               // contenidoConFormato.EsDisposicionEspecial = (EsDisposicionEspecial) ? 'Si' : 'No';
                archivoConFormato.EstaActivo = {
                    activo: (a.Activo == true),
                    html: `<label id="switch-activo-inactivo-MIC-${ a.ArchivoDeContenidoMicrositioId }" class="switch-contenido-activo-MIC">
                            <input id="check-contenido-activo-MIC-${ a.ArchivoDeContenidoMicrositioId }" type="checkbox">
                            <div id="slider-activo-inactivo-MIC-${ a.ArchivoDeContenidoMicrositioId }" class="slider-contenido-activo-MIC"></div>
                           </label>`
                };
                return archivoConFormato;
            });
        },
        llenarTablaDeContenidosDeCarrusel: async function(elementos){
         await Promise.resolve(this.darFormatoObjetosDeArchivosDeContenido(elementos));
         this.mostrarBotonOrden=true;
          this.mostrarTablaContenidoCarrusel=true; 
          $("#contenidos_seccion").hide();
          $("#contenido-carrusel").show();       
          $("#tabla-contenidos-carrusel").bootstrapTable({data: this.archivosDeContenidos.listaDeArchivos});
          $("#tabla-contenidos-carrusel").bootstrapTable('load', this.archivosDeContenidos.listaDeArchivos);
           $('#tabla-contenidos-carrusel').on('page-change.bs.table', (size, number) => {
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchArchivosActivos());
                });
            });
          
         
        },
  evtSeleccionoTodos: function(e, rows) {
            this.contenidos.contenidosSeleccionados = rows.map(csel => {
                let contenidoObj = {};
                contenidoObj.ContenidoDeMicrositioId = csel.ContenidoDeMicrositioId;
                contenidoObj.TipoEstatusDelContenido = {
                    TipoEstatusDelContenidoId: 4
                };
                // estos valores no se actualizaran solo se llenan porque no son valores nullables de la entidad, es 
                // para prevenir error en la conversion de la peticion en controller
                contenidoObj.FechaDePublicacion = csel.FechaDePublicacion;
                contenidoObj.FechaDeRegistro = csel.FechaDeRegistro;
                //contenidoObj.EsDisposicionEspecial = (csel.EsDisposicionEspecial == 'Si') ? true : false;
                //contenidoObj.MostrarArchivos = csel.MostrarArchivos;
                return contenidoObj;
            })
        },
 evtSeleccionoContenido: function(e, row) {
            if(!this.contenidos.contenidosSeleccionados.some(csel => csel.ContenidoDeMicrositioId == row.ContenidoDeMicrositioId))
                this.contenidos.contenidosSeleccionados.push(row);
        },

         evtRemoverContenidosEnListaSeleccionados: function(e, rows, tipoCheck) {
            switch(tipoCheck) {
                case 'UNO':
                    this.contenidos.contenidosSeleccionados = this.contenidos.contenidosSeleccionados.filter(csel => csel.ContenidoDeMicrositioId != rows.ContenidoDeMicrositioId);
                    break;
                case 'MUCHOS':
                    // se remueven la paginacion de contenidos seleccionados
                    this.contenidos.contenidosSeleccionados = this.contenidos.contenidosSeleccionados.filter(csel => {
                        return !rows.some(crsel => {
                            return csel.ContenidoDeMicrositioId == crsel.ContenidoDeMicrositioId;
                        });
                    });
                    break;
                default:
                    break;
            }
        },    
      },
 
      
      created() {
 this.$nextTick(() => {
            $("#tabla-contenidos").bootstrapTable({  data: this.contenidos.listaDeContenidos });      
            $("#tabla-contenidos").bootstrapTable('load',  this.contenidos.listaDeContenidos); 
        });

        window.operateEvents = {
         
    'click #btnEditar':(e, value, row, index) => {
     // window.addEventListener('click', this.funcionDePrueba);
          $("#contenidos_seccion").hide();
          $("#contenido-carrusel").hide();
        this.agregarContenidoAFormulario(row);
      // alert('You click like action, row: ' + JSON.stringify(row))
    },
    'click #btnCancelar': (e, value, row, index) => {
       row.EsArchivoDeContenido=false;
      row.EsContenido=true;
      this.confirmarCanceladoDeContenido(row);

    },
    'click #btnDesactivar': (e, value, row, index) => {
      row.EsArchivoDeContenido=true;
      row.EsContenido=false;
      this.confirmarCanceladoDeContenido(row,index)
    },
      'click :checkbox': (e, value, row, index) => {
      this.cancelarContenido(row,index)
            },
     'click #btnCopiar': (e, value, row, index) => {
       var rutaDescarga = (row.RutaDeArchivo.indexOf("C:") == 0)? row.ArchivosDeContenidoMicrositios[0].RutaDelArchivo.replace(this.SERVIDOR_LOCAL,enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos)  :  row.RutaDeArchivo.replace(this.SERVIDOR_LOCAL,enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos);
       rutaDescarga=this.$root.$el.baseURI.replace(this.$route.path,this.RUTA_VISOR+rutaDescarga)
       var aux = document.createElement("input");
       aux.setAttribute("value",rutaDescarga);
       document.body.appendChild(aux);
       aux.select();
       document.execCommand("copy");
       document.body.removeChild(aux);

    },
  }


      },
      mounted() {
       $("#contenidos_seccion").show();
       $("#contenido-carrusel").hide(); 
      },
      computed: {
        /**
         * Funciones encargadas de modificar variables de store.
         */
           obtenerTituloDeSeccion() {
            return this.$store.getters.Get_SICPO_Micrositio_establecerPunteroDeContenidoActual.rutaSecciones;
        },
        mostrarFormularios() {
           return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_mostrarFormularios;
        },
        mostrarPasoTres() {
           return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_mostrarPasoTres;
        },
        modificoOrdenDeContenidos(){
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioOrdenlistaContenidos;
        },
      mostrarFormulariosDeEdicion(){
        return this.$store.getters.Get_SICPO_Micrositio_Edicion_mostrarTablaDeContenidos;
      }
      },
    
  }
</script>

<style scoped>
.thead-green{
  background-color: var(--verde-pj-100);
}


/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-contenido-activo-MIC {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

.switch-contenido-activo-MIC input {display:none;}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC {
  background-color: #2ab934;
}

.switch-contenido-activo-MIC input:focus + .slider-contenido-activo-MIC {
  box-shadow: 0 0 1px #2196F3;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:after
{  
  content:'';
}


#titulo-resultados {
    background-color: var(--verde-pj);
    padding: 13px;
    padding-left: 33px;
    margin-bottom: 0px;
}
#titulo-resultados h4 {
  color : white;
}
.texto-ajustable {
     font-size : 100px !important;
     margin-right: 0px !important;
}

.padding-bottom{
  padding-bottom: 1em;
}
  .tipoDePagina_DIV {
      display: flex;
  }

  #subidordearchivos_div {
      text-align: center
  }

  .vr {
      width:1px;
      background-color: white;
      margin-left: 15px;
  }
  
  .paso{
    margin: 1em;
    width: 48%;
  }
  h1,h4{
    user-select: none;
  }


  .nav_tab_formularios {
    padding: 25px;
    background-color: var(--gris-pj-100);
    box-shadow: 0px 6px 20px 4px #161616;
  }
  .nav-tabs
  {
    border-bottom: 1px solid white;
  }

  .nav-item>a.active, 
  .nav-item>a.active:focus, 
  .nav-item>a.active:hover {
    background-color: #323335;
    color: white;
    border-bottom: 1px solid #323335;
  }
  .nav-item>a{
    border-bottom: 1px solid white;
  }

</style>

<style>
/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-contenido-activo-MIC {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

.switch-contenido-activo-MIC input {display:none;}

.slider-contenido-activo-MIC {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider-contenido-activo-MIC:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC {
  background-color: #2ab934;
}

.switch-contenido-activo-MIC input:focus + .slider-contenido-activo-MIC {
  box-shadow: 0 0 1px #2196F3;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.slider-contenido-activo-MIC:after
{
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:after
{  
  content:'';
}

/* dropdown tabla de contenidos */
#tabla-resultados-edicion-SICPO .search {
    width: 20rem;
}

#tabla-resultados-edicion-SICPO .dropdown-toggle {
    width: 3.3rem;
}

/* #tabla-resultados-edicion-SICPO .pagination > li > a {
    background-color: white;
    color: #121213;
}

#tabla-resultados-edicion-SICPO > li > a:focus,
#tabla-resultados-edicion-SICPO > li > a:hover,
#tabla-resultados-edicion-SICPO > li > span:focus,
#tabla-resultados-edicion-SICPO .pagination > li > span:hover
{
    color: #111011;
    background-color: #eee;
    border-color: #ddd;
}

#tabla-resultados-edicion-SICPO .pagination > .active > a {
    color: white;
    background-color:  black;
    border: solid 1px #39373d;
}

#tabla-resultados-edicion-SICPO .pagination > .active > a:hover {
    background-color:  black;
    border: solid 1px #39373d;
} */
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/EdicionContenidoMicrositio.vue